<template>
  <div class="container search">
    <app-page-search :title="title"></app-page-search>

    <div class="search-info">
      <div class="exclude">
        <span>Ваш запрос:</span> {{ $route.query.k }}
      </div>
      <div>
        <span>Всего найдено:</span> {{ getTotalCount() }}
      </div>
    </div>

    <div class="search-results">
      <div v-for="(document, idx) of results" :key="document.guid" class="item">
        <div class="item__index">{{ idx + 1 }}</div>
        <div class="item-body">
          <div class="item-body__head">
            <router-link :to="getLink(document)" class="item-body__title">{{ document.type === 'training-center' ?  document.description : document.title }}</router-link>
            <img v-if="document.type !== 'manager-competency'" :src="getIcon(document.icon)" class="item-body__icon">
          </div>
          <div class="item-body__description" v-html="getDescription(document)"></div>
          <router-link :to="getCategoryLink(document)" class="item-body__category">{{ typeMap[document.type] }}</router-link>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm load-more">
        <button v-show="hasMore && !loading" class="btn btn-feedback btn-outline" @click="loadMore">Загрузить ещё</button>
        <app-spinner v-show="loading"></app-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { AppPageSearch } from "@/components";
import { AppSpinner } from "@/components";
import { search } from "@/api";
import { typeMap, linkMap } from "@/utils/helpers";

export default {
  name: "Search",
  components: {
    AppPageSearch,
    AppSpinner
  },

  data: () => ({
    title: "Результаты поиска",
    results: [],
    loading: false,
    page: 1,
    totalCount: "",
    typeMap,
    linkMap
  }),
  computed: {
    hasMore() {
      return this.results.length < this.totalCount;
    }
  },
  watch: {
    "$route.query.k"() {
      this.results = [];
      this.loadResults();
    }
  },
  created() {
    this.loadResults();
  },
  methods: {
    async loadResults(params = {}) {
      params.k = this.$route.query.k;
      this.loading = true;

      const response = await search(params);
      this.totalCount = response.meta.pagination.total;
      this.results = this.results.concat(response.data);

      this.loading = false;
    },
    loadMore() {
      this.page += 1;
      this.loadResults({ page: this.page });
    },
    getLink(item) {
      if (item.type === "regulation/doc") {
        return `regulations?docId=${item.guid}`;
      }
      if (item.type === "competency/doc") {
        return `/competencies/${item.parent.parent.guid}/categories/${
          item.parent.guid
        }`;
      }
      if (item.type === "competency" && !item.parent) {
        return "/competencies";
      }
      if (item.type === "competency" && item.parent) {
        return `/competencies/${item.parent.guid}/categories/${item.guid}`;
      }
      if (item.type === "training-center") {
        return `training-centers?title=${item.title}`;
      }
      if (item.type === "manager-competency") {
        return `managers?title=${item.title}`;
      }
      if (item.type === "faq") {
        return `faq?guid=${item.guid}`;
      }
      return "/";
    },
    getCategoryLink(item) {
      if (item.type === "competency/doc") {
        return `/competencies/${item.parent.parent.guid}/categories/${
          item.parent.guid
        }`;
      }
      return linkMap[item.type];
    },
    getIcon(icon) {
      if (icon === "txt") return "/images/document.svg";
      return icon;
    },
    getDescription(document) {
      if (document.type === "training-center") {
        const a = document.title.split(",");
        a.shift();
        return a.join(",");
      }
      return document.description;
    },
    getTotalCount() {
      if (this.totalCount === 1) return `${this.totalCount} совпадение`;
      if (this.totalCount < 5) return `${this.totalCount} совпадения`;
      return `${this.totalCount} совпадений.`;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-info {
  padding-top: 45px;

  span {
    font-size: 15px;
    line-height: 18px;
    font-weight: 300;
    color: #9c9a9a;
    margin-right: 20px;
  }
  div {
    margin-bottom: 25px;
    font-size: 20px;
    line-height: 23px;
    font-weight: 500;
  }
}

.search-results {
  padding-top: 35px;
}

.item {
  display: flex;
  font-size: 20px;
  line-height: 23px;
  font-weight: 500;
  margin-bottom: 30px;

  &__index {
    min-width: 40px;
  }

  .item-body {
    &__head {
      display: flex;
      align-items: center;
      margin-bottom: 11px;
    }

    &__title {
      font-size: 20px;
      line-height: 23px;
      font-weight: 500;
      color: #000000;
    }

    &__icon {
      width: 12px;
      height: 16px;
      margin-left: 10px;
    }

    &__description {
      color: #9c9a9a;
      @include font-13-regular;
      margin-bottom: 5px;

      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &__category {
      color: #103677;
      @include font-13-regular;
    }
  }
}
</style>
